var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8857 16.5699L19.7009 14.2046L15.5148 16.5707L19.6996 18.9293L23.8857 16.5699ZM24.7241 17.9887L20.5367 20.3488V25.0889L24.7241 22.7221V17.9887ZM18.8624 25.0873V20.3488L14.6777 17.9903V22.7221L18.8624 25.0873Z",
    fill: "#00A6ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46505 20.0586L5 17.6455L5.93026 16.7349L9.32558 20.0586L5.93026 23.3824L5 22.4718L7.46505 20.0586Z",
    fill: "#1A1F36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4553 20.0584L7.99023 17.6453L8.9205 16.7346L12.3158 20.0584L8.9205 23.3822L7.99023 22.4715L10.4553 20.0584Z",
    fill: "#1A1F36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4437 11.0011C16.6226 11.2308 14.9671 11.9778 13.636 13.0867L9.31445 8.85625C11.7665 6.67773 14.9406 5.26407 18.4437 5.00012V11.0011Z",
    fill: "#1A1F36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7077 13.1408C24.3947 12.0267 22.7585 11.2678 20.9552 11.017V5.00959C24.4407 5.29886 27.5947 6.72688 30.0274 8.91212L25.7077 13.1408Z",
    fill: "#1A1F36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8965 19.5316C28.8096 17.8583 28.2596 16.3047 27.3695 14.991L31.7351 10.7175C33.6937 13.1599 34.8971 16.2103 35.0009 19.5316H28.8965Z",
    fill: "#1A1F36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7017 25.8772C27.6583 24.7767 28.3512 23.4499 28.6849 21.9903H34.8749C34.4558 25.0944 33.0699 27.9 31.0232 30.1076L26.7017 25.8772Z",
    fill: "#1A1F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9552 28.9829C22.3752 28.7854 23.6915 28.2729 24.828 27.52L29.1887 31.7889C26.8884 33.5768 24.0527 34.7333 20.9552 34.9903V28.9829Z",
    fill: "#1A1F36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4437 28.9988C17.0079 28.8177 15.6751 28.3151 14.5229 27.567L10.1574 31.8405C12.4754 33.6219 15.3296 34.7651 18.4437 34.9998V28.9988Z",
    fill: "#1A1F36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/modules.f014cbe634093fafb8a9bb10a2db9bf2.svg";
export { ForwardRef as ReactComponent };